import Column from '../core/components/box/column';
import Banner from './banner';
import Contact from './contact';
import Footer from './footer';
import Notice from './notice';
import Services from './services';
import VisionAndMission from './visionAndMission';

interface HomePageProps {}
const HomePage = (props: HomePageProps) => {
  return (
    <Column>
      <Banner />
      <Services />
      <VisionAndMission />
      <Notice />
      <Contact />
      <Footer />
    </Column>
  );
};

export default HomePage;
